var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditMsgIcon34377(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34377",
    "data-name": "Group 34377",
    transform: "translate(-140.001 -42.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 16,
    height: 16,
    transform: "translate(140.001 42.001)",
    fill: "rgba(139,68,68,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pencil_1_",
    "data-name": "pencil (1)",
    transform: "translate(141.617 43.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40361",
    "data-name": "Path 40361",
    d: "M.469,12.767a.406.406,0,0,1-.394-.5L.838,9.2a.407.407,0,0,1,.107-.189L9.525.434a1.491,1.491,0,0,1,2.105,0L12.4,1.2a1.491,1.491,0,0,1,0,2.105l-8.58,8.581a.4.4,0,0,1-.189.107l-3.059.762a.375.375,0,0,1-.1.012ZM1.6,9.509,1.026,11.8l2.294-.572,8.5-8.5a.678.678,0,0,0,0-.957l-.765-.765a.678.678,0,0,0-.957,0ZM3.528,11.6h0Zm0,0",
    transform: "translate(-0.063 0.001)",
    fill: "#6a92c5",
    stroke: "#6a92c5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40362",
    "data-name": "Path 40362",
    d: "M318.876,67.605a.4.4,0,0,1-.287-.119l-2.3-2.3a.406.406,0,0,1,.574-.574l2.3,2.3a.406.406,0,0,1-.288.693Zm0,0",
    transform: "translate(-308.151 -62.86)",
    fill: "#6a92c5",
    stroke: "#6a92c5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40363",
    "data-name": "Path 40363",
    d: "M32.8,353.664a.4.4,0,0,1-.287-.119l-2.3-2.3a.406.406,0,1,1,.574-.574l2.3,2.3a.406.406,0,0,1-.287.693Zm0,0",
    transform: "translate(-29.331 -341.659)",
    fill: "#6a92c5",
    stroke: "#6a92c5",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMsgIcon34377);
export default __webpack_public_path__ + "static/media/edit-msg-icon34377.b569e158.svg";
export { ForwardRef as ReactComponent };